<div class="single-feature" [class]="color" [class.feature-selected]="value" (click)="toggleValue()">

  <h4 class="mb-2" *ngIf="value">{{fancyLabel | titlecase}}</h4>
  <h4 class="mb-2" *ngIf="!value">{{fancyUnchecked | titlecase}}</h4>
  <div class="select-icon" [class]="color">
    <i *ngIf="value && color !== 'danger'" class="fa fa-check-circle"></i>
    <i *ngIf="value && color === 'danger'" class="fa fa-times-circle"></i>
  </div>
  <p [class.text-white]="color === 'main'" *ngIf="value">{{checkedLabel}}</p>
  <p [class.text-theme-primary]="color === 'main'" *ngIf="!value">{{unCheckedLabel}}</p>

</div>
